/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Textarea,
  useToast,
  VStack,
  Text,
} from "@chakra-ui/react";
import api from "utils/api";

export default function NotEkleModal({ isOpen, onClose, aracData, onSuccess }) {
  const toast = useToast();
  const [notMetni, setNotMetni] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setNotMetni("");
    }
  }, [isOpen]);

  const handleSave = async () => {
    if (!notMetni.trim()) {
      toast({
        title: "Hata",
        description: "Not metni boş olamaz.",
        status: "warning",
        duration: 3000,
      });
      return;
    }

    if (!aracData?.id) {
      toast({
        title: "Hata",
        description: "Araç bilgisi bulunamadı.",
        status: "error",
        duration: 3000,
      });
      return;
    }

    try {
      setSaving(true);
      const res = await api.post(`/api/devices/${aracData.id}/note`, {
        not_metni: notMetni.trim(),
      });
      const data = await res.json();
      
      if (!res.ok) {
        throw new Error(data?.detail || "Not eklenemedi.");
      }

      toast({
        title: "Başarılı",
        description: "Not başarıyla eklendi.",
        status: "success",
        duration: 3000,
      });

      // Güncellenmiş device verisini onSuccess callback'ine geç
      onSuccess?.(data);
      onClose();
    } catch (err) {
      toast({
        title: "Hata",
        description: err.message,
        status: "error",
        duration: 4000,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered motionPreset="slideInBottom">
      <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
      <ModalContent borderRadius="2xl" boxShadow="xl" maxW="520px" bg="white" p={1}>
        <ModalHeader textAlign="center" py={2}>
          <VStack spacing={1}>
            <Text fontSize="lg" fontWeight="medium" color="gray.800">
              Not Ekle
            </Text>
            <Text fontSize="xs" color="gray.400">
              {aracData?.plaka || "Araç"} için not ekleyin
            </Text>
          </VStack>
        </ModalHeader>
        <ModalCloseButton size="sm" />
        <ModalBody px={6} py={4}>
          <FormControl>
            <FormLabel fontSize="sm" color="gray.600">Not Metni</FormLabel>
            <Textarea
              value={notMetni}
              onChange={(e) => setNotMetni(e.target.value)}
              placeholder="Notunuzu buraya yazın..."
              rows={6}
              resize="vertical"
              size="sm"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter px={6} py={4}>
          <Button variant="ghost" mr={3} onClick={onClose} size="sm">
            İptal
          </Button>
          <Button colorScheme="blue" onClick={handleSave} isLoading={saving} size="sm">
            Kaydet
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

